// 🟦 = blocked
// ⬜ = selected
// ⬛ = empty
// 🔳 = seat/click

export default {

  '🔳🔳⬜⬜⬛': [
    ({ block }) => block.count() == 2 && block.isSelected(1) && block.isEmpty(2),
    ({ block }) => ({
      deselect: block.next().seats.slice(-1),
      select: block.seats,
      valid: false,
      stop: true,
    })
  ],

  '⬛⬜⬜🔳🔳': [
    ({ block }) => block.count() == 2 && block.isSelected(-1) && block.isEmpty(-2),
    ({ block }) => ({
      deselect: block.prev().seats.slice(0, 1),
      select: block.seats,
      valid: false,
      stop: true,
    })
  ],

  '🔳🔳⬜⬜🟦': [
    ({ block }) => block.count() == 2 && block.isSelected(1),
    ({ seat }) => ({
      select: seat.last(),
      valid: false,
      stop: true,
    })
  ],

  '🟦⬜⬜🔳🔳': [
    ({ block }) => block.count() == 2 && block.isSelected(-1),
    ({ seat }) => ({
      select: seat.first(),
      valid: false,
      stop: true,
    })
  ],

  '🟦⬛🔳⬛⬛': [
    ({ seat, block }) => seat.isFirst(-1) && block.count() > 2,
    ({ seat }) => ({
      select: seat.prev(),
      valid: false,
      stop: false,
    })
  ],

  '⬛⬛🔳⬛🟦': [
    ({ seat, block }) => seat.isLast(1) && block.count() > 2,
    ({ seat }) => ({
      select: seat.next(),
      valid: false,
      stop: false,
    })
  ],

}
